export const globalVariable = 'http://localhost:3000';
